import { Injectable } from '@angular/core';

import { BaseHttpService } from '@common/services/REST/base.http.service';
import { type NPSFeedback } from '@ui/sp-nps/nps-modal.component';
import { map, type Observable } from 'rxjs';
import type { HttpDataResponse } from '@common/types/http-response.type';

export type NpsData = {
    id: number;
    userId: number;
    rating: number;
    comment: string;
    createdAt: Date;
    sessionNumber: number;
};

@Injectable({
    providedIn: 'root',
})
export class NpsHttpService extends BaseHttpService {
    public getNpsData(): Observable<NpsData[]> {
        return this.http.get<HttpDataResponse<NpsData[]>>(this.formatApiUrl('nps')).pipe(map((res) => res.data));
    }

    public setNpsData(feedback: NPSFeedback, pageId?: number): Observable<NpsData> {
        const payload: NPSFeedback & { pageId?: number } = feedback;

        if (pageId) {
            payload.pageId = pageId;
        }
        return this.http.post<NpsData>(this.formatApiUrl('nps'), payload);
    }
}
// }
